import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    {
      title: "Resources",
      links: [
        { to: "/categories", label: "navCategories" },
        { to: "/guides", label: "navGuides" },
        { to: "/shipping", label: "navShipping" },
        { to: "/reviews", label: "navReviews" },
      ],
    },
    {
      title: "Legal",
      links: [
        { to: "/about", label: "navAbout" },
        { to: "/disclaimer", label: "footerDisclaimer" },
        { to: "/privacy-policy", label: "footerPrivacy" },
        { to: "/terms", label: "footerTerms" },
      ],
    },
    {
      title: "Support",
      links: [
        { to: "/faq", label: "navFaq" },
        { to: "/contact", label: "navContact" },
        { to: "/safety", label: "navSafety" },
        { to: "/comparisons", label: "navComparisons" },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-table-2 text-background-50 text-lg" />
              </div>
              <span className="font-heading font-bold text-lg text-foreground-900">
                {t("siteName")}
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              {t("heroSubtitle")}
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors"
              >
                {t("ctaVisitMain")}
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 uppercase tracking-wider mb-4">
                {section.title}
              </h3>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors"
                    >
                      {t(link.label)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Editorial Notice */}
        <div className="mt-10 pt-8 border-t border-background-200/70">
          <p className="text-xs text-foreground-500 leading-relaxed mb-4">
            {t("editorialDesc")}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              © 2026 AllChinaBuy Spreadsheet. {t("trustIndependent")}
            </p>
            <div className="flex items-center gap-4">
              <span className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-global-line" />
                EN / FR / DA / DE
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-time-line" />
                {t("lastUpdated")}: 2026-08-25
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}